import { makeStyles } from '@mui/styles';

const useNavbarStyles = makeStyles((theme) => ({
  appBar: {
    padding: '0 0',
    width: '100%',
    maxWidth: 'none',
    margin: '0 0',
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    zIndex: 20000,
    position: 'fixed',
  },
  //Transparent Navbar only in Homepage
  navTransparent: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  //solid navbar
  navScrolled: {'&.MuiAppBar-root': {
    backgroundColor: '#FFFFFF !important',
    color: theme.palette.text.primary + ' !important',
    boxShadow: theme.shadows[4]+' !important',
    transition: 'background-color 0.5s ease, color 0.5s ease',}
  },
  toolbar: {
    paddingTop:'2rem',
    paddingBottom:'0.8rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingRight:'7rem',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingTop:'1.3rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingTop:'0.8rem',
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    paddingLeft: '3rem',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0rem',
    },
  },
  logoImage: {
    height: 42,
    width: 'auto',
    marginLeft: "2rem",
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0.5rem',
    },
  },
  logoWhite: {
    textTransform: 'uppercase',
    fontSize: '0.9rem',
    color:'#fff',
    cursor: 'pointer',
    paddingLeft: '1.5rem',
    transition: 'color 0.3s ease, opacity 0.3s ease', '&:hover':
    {
      color: '#fff',
      opacity: 0.6,
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '1.5rem !important',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1.1rem !important',
    },
  },
  logoDark:{
    textTransform: 'uppercase',
    fontSize: '0.9rem',
    color: theme.palette.text.primary,
    paddingLeft: '1.5rem',
    cursor: 'pointer',
    transition: 'color 0.3s ease, opacity 0.3s ease',
    '&:hover': {
      color: theme.palette.text.primary,
      opacity: 0.6,
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '1.5rem !important',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '1.1rem !important',
    },
  },
  svglogoWhite: {
    filter: 'invert(1)',
    transition: 'filter 0.3s ease-in-out',
    opacity: 0.9,
  },
  svglogoDark: {
    filter: 'invert(0)',
    transition: 'filter 0.3s ease-in-out',
  },
  //navbar for larger screen
  defaultNavbarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  buttonGroup: {
    display: 'flex',
    gap: '1.5rem',
    justifyContent: 'center',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      // Hide buttons on mobile screens
      display: 'none',
    },
    '& .MuiButton-root': {
      fontSize: '0.75rem',
    },
  },
  //White navbar buttons when the navbar is transparent
  navButtonWhite:{
    '&.MuiButton-root': {
      fontSize: '0.9rem',
      color: '#fff !important',
      borderRadius: '5px',
      padding: '0.5rem 0.5rem',
      transition: 'all 0.3s ease',
     '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
    },
  },
  //dark navbar buttons when the navbar is dark
  navButtonDark:{
    '&.MuiButton-root': {
      fontSize: '0.9rem',
      color: theme.palette.text.primary,
      borderRadius: '5px',
      padding: '0.5rem 0.5rem',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    },
  },

  placeholder: {
    width: '18rem',
    [theme.breakpoints.down('sm')]: {
      // Hide placeholder on smaller screens
      display: 'none',
    },
  },

  //HamburgerMenu for smaller screen size
  hamburgerMenu: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  hamburgerMenuIcon: {
    color: '#fff !important',
    paddingRight: '2rem !important',
    transition: 'color 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  iconDark: {
    color: theme.palette.text.primary,
  },
  iconSize: {
    fontSize: '2.1rem !important',
  },
  closeIcon: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    zIndex: 1301 + 'important',
    color: '#fff',
    opacity: 1,
    transition: 'color 0.3s ease, transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.2)',
      color: '#f1f1f1',
    },
    '&.dark': {
      color: theme.palette.text.primary,
    },
  },
  activeCloseIcon: {
    transition: 'transform 0.3s ease, color 0.3s ease',
    transform: 'scale(1.1)',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  },
  drawer: {
    margin: '0 auto',
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.9)!important',
    borderRadius: '15px',
    width: '80%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    marginTop: '6rem',
    padding: '1rem',
  },
  drawerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
  },
  drawerItem: {
    marginLeft:'1rem!important',
    fontSize: '1rem',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  drawerIcon: {
    width: '25px',
    height: '25px',
    marginRight: '1rem !important',
    paddingLeft:'0.5rem !important',
    display: 'inline-block',
    opacity: 0.8,
    transition: 'opacity 0.3s ease',
  }
}));

export default useNavbarStyles;